import { Pipe, PipeTransform } from '@angular/core';

import { MarkdownService } from '../services/shared/markdown.service';

/**
 * Pure pipe wrapper for `MarkdownService.formatMessage`. Used in the AI
 * assistant chat to convert streamed assistant content into safe HTML
 * for `[innerHTML]` binding.
 *
 * Why a pipe rather than a component-method binding:
 *   `<span [innerHTML]="formatMessage(msg.content)"></span>`
 * Angular re-invokes that method on every change-detection pass,
 * regardless of whether `msg.content` actually changed. Mid-stream with
 * ~20 delta events/second and N assistant bubbles in the conversation,
 * that's a markdown re-parse per bubble per CD pass — wasteful and a
 * real source of jank in long sessions.
 *
 * Pure pipes (`pure: true`, the default) memoize on input identity:
 * the same input string returns the cached output, no re-parse.
 */
@Pipe({
    name: 'markdown',
    standalone: true,
})
export class MarkdownPipe implements PipeTransform {
    constructor(private readonly _markdown: MarkdownService) {}

    transform(value: string | null | undefined): string {
        if (!value) {
            return '';
        }
        return this._markdown.formatMessage(value);
    }
}
